import ExpenseForm from "../ExpenseForm";
import useExpenseFormData from "../hooks/useExpenseFormData";
import SpinnerWrapper from "../../../conponents/pages/spinnerWrapper";
import { PuffLoader } from "react-spinners";


const AddExpensePage = () => {

    // const subscription = useSubscription(user);

    // const canAttach =

    //     subscription.canUse(

    //         "attachments",

    //         attachmentCount

    //     );

    // const remaining =

    //     subscription.remaining(

    //         "attachments",

    //         attachmentCount

    //     );

    // if(subscription.isFree){

    // }
    
    // if(subscription.isTrial){
    
    // }
    
    // if(subscription.isPro){
    
    // }

    const {

        cars,

        categories,

        loading,

        error,

    } = useExpenseFormData();

    if (loading) {

        // return <LoadingPage />;
        return (
            <SpinnerWrapper>
              <PuffLoader color="green" loading={true} size={60} />
            </SpinnerWrapper>
          );

    }

    if (error) {

        return (

            <div>

                خطا در بارگذاری اطلاعات

            </div>

        );

    }

    return (

        <ExpenseForm

            cars={cars}

            categories={categories}

        />

    );

};

export default AddExpensePage;